import React, { useEffect, useState, useMemo } from "react";
import { Dialog, Grid } from "@mui/material/";
import {
  Button,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

const SessionExpired = () => {
  const [openDialog, setOpenDialog] = useState(true);
  const handleCloseDialog = () => {
    setOpenDialog(false);
    localStorage.clear();
    window.location.href = "/";
  };
  return (
    <Dialog open={true} maxWidth="xs" className="sessionExpired">
      <DialogTitle>Your session has expired</DialogTitle>
      <DialogContent>
        <DialogContentText>Please login again</DialogContentText>
        <Button
          variant="outlined"
          color="primary"
          onClick={handleCloseDialog}
          className="goToLogin"
        >
          Go to login
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default SessionExpired;
